export default __webpack_public_path__ + "static/media/error.28003fa0.jpg";